var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-gridview',{attrs:{"parentData":{
               tabHeaders: this.dataHeader,
               tabItems: this.dataItems,
               pageTitle: this.pageTitle,
               search: this.search,
           }},on:{"EditItem":function($event){return _vm.editItemHandler($event)},"DeleteItem":function($event){return _vm.deleteItemHandler($event)},"NewPressed":_vm.newRecordHandler},scopedSlots:_vm._u([{key:`item.rebatelimitamount`,fn:function({ item }){return [_vm._v(" "+_vm._s(item.rebatelimitamount ? Number(item.rebatelimitamount).toLocaleString('en-MY', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '')+" ")]}}],null,true)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }